
<div>
	<form id="billComparisonForm" [formGroup]="formGroup" (ngSubmit)="onSubmit()" >

		<input type="hidden" formControlName="id" />
		<input type="hidden" formControlName="providerCompanyId" />

		<div class="center-div">
			<h1 class="header-center">Florida Municipal Electric Association</h1>
			<h3 class="header-center" style="padding: 20px;">Monthly Bill Comparison</h3>
		</div>
		

		<div class="center-div row">
			<div class="col-md-3">
				<label><b>Utility Provider:</b></label>
				<p>{{model.utilityProvider}}</p>
			</div>

			<div class="col-md-3">
				<label><b>Usage Year/Month:</b></label>
				<p>{{model.yearMonth}}</p>
			</div>	
			
			<div class="col-md-3">
				<label><b>Submitted By:</b></label>
				<p>{{model.submittedBy}}</p>
			</div>
			<div class="col-md-3">
				<button (click)="recertify();" *ngIf="canEdit" type="button" class="btn btn-sm btn-success">Recertify Previous Month</button>
			</div>
		</div>

		<div class="row center-div" style="text-align:center ;" >
			<h5 class="col-md-12" >*Do not include gross receipt tax.*</h5>
		</div>
		
		<div class="row center-div" style="position: relative;">
			<h4 class="col-md-6 table-header-format">Residential Service</h4>
			<div class="col-md-6 row" style="justify-content: right;">
				<label><b>Residential Customer Charge:</b></label>
				<div style="padding-left: 10px;" >			
					<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.customerCharge" [ngModelOptions]="{ standalone: true }"
						class="form-control input-field col-md-12" required maxlength="9" pcgDecimalNumber pcgCurrency style="width: 100%;"/>
					<span *ngIf="!canEdit">{{ model.customerCharge | currency}}</span>
				</div>
			</div>
		</div>
		
		<div class="col-md center-div">
			<table class="data-grid">
				<thead class="daily-count-tbl">
					<tr>
						<th></th>
						<th class="admin align-right">1,000 kWh</th>
						<th class="hand align-right">1,200 kWh</th>
						<th class="hand align-right">2,500 kWh</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>Base Rate</td>
						<td class="align-right"  data-label="1,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.baseRate1000KWH" [ngModelOptions]="{ standalone: true }" 
								class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgNumberDecimal pcgCurrency/>
							<span *ngIf="!canEdit" class="input-field">{{ model.baseRate1000KWH | currency}}</span>
						</td>
						<td class="align-right" data-label="1,200 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.baseRate1200KWH" [ngModelOptions]="{ standalone: true }"
								class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency/>
							<span *ngIf="!canEdit" class="input-field">{{ model.baseRate1200KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="2,500 KWH">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.baseRate2500KWH" [ngModelOptions]="{ standalone: true }"
								class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency/>
							<span *ngIf="!canEdit" class="input-field">{{ model.baseRate2500KWH | currency }}</span>
						</td>
					</tr>
					<tr>
						<td>Fuel Adj.</td>
						<td class="align-right" data-label="1,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.fuelAdj1000KWH" [ngModelOptions]="{ standalone: true }" 
								class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency allowNegative="true"/>
							<span *ngIf="!canEdit" class="input-field">{{ model.fuelAdj1000KWH | currency}}</span>
						</td>
						<td class="align-right" data-label="1,200 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.fuelAdj1200KWH" [ngModelOptions]="{ standalone: true }"
								class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency allowNegative="true"/>
							<span *ngIf="!canEdit" class="input-field">{{ model.fuelAdj1200KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="2,500 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.fuelAdj2500KWH" [ngModelOptions]="{ standalone: true }"
								class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency allowNegative="true"/>
							<span *ngIf="!canEdit" class="input-field">{{ model.fuelAdj2500KWH | currency }}</span>
						</td>
					</tr>
					<tr *ngIf="model.isInvestorOwned">
						<td>Storm Hardening</td>
						<td class="align-right" data-label="1,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.stormHardening1000KWH" [ngModelOptions]="{ standalone: true }" 
								class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency/>
							<span *ngIf="!canEdit" class="input-field">{{ model.stormHardening1000KWH | currency}}</span>
						</td>
						<td class="align-right" data-label="1,200 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.stormHardening1200KWH" [ngModelOptions]="{ standalone: true }"
								class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency/>
							<span *ngIf="!canEdit" class="input-field">{{ model.stormHardening1200KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="2,500 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.stormHardening2500KWH" [ngModelOptions]="{ standalone: true }"
								class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency/>
							<span *ngIf="!canEdit" class="input-field">{{ model.stormHardening2500KWH | currency }}</span>
						</td>
					</tr>
					<tr>
						<td>Total</td>
						<td class="align-right" data-label="1,000 kWh">
							<span class="input-field">{{ +model.baseRate1000KWH + +model.fuelAdj1000KWH + +model.stormHardening1000KWH  | currency }}</span>
						</td>
						<td class="align-right" data-label="1,200 kWh">
							<span class="input-field">{{ +model.baseRate1200KWH + +model.fuelAdj1200KWH + +model.stormHardening1200KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="2,500 kWh">
							<span class="input-field">{{ +model.baseRate2500KWH + +model.fuelAdj2500KWH + +model.stormHardening2500KWH | currency  }}</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="row center-div">
			<h4 class="col-md-6 table-header-format">Commercial Service</h4>
			
		</div>
		

		<div class="col-md center-div">	
			<table class="data-grid">
				<thead>
					<th></th>
					<th></th>
					<th>Non-Demand</th>
					<th></th>
					<th>Demand</th>
				</thead>
				<thead class="daily-count-tbl">
					<tr>
						<th></th>
						<th class="admin align-right">750 kWh</th>
						<th class="hand align-right">1,500 kWh</th>
						<th class="hand align-right">30 KW 6,000 kWh</th>
						<th class="hand align-right">40 KW 10,000 kWh</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>Base Rate</td>
						<td class="align-right" data-label="750 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.baseRate750KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.baseRate750KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="1,500 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.baseRate1500KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.baseRate1500KWH | currency }}</span>
						</td>
						<td class="align-right multi-line" data-label="30 kW &#010; 6,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.baseRate30KW6000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.baseRate30KW6000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="40 kW 10,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.baseRate40KW10000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.baseRate40KW10000KWH | currency }}</span>
						</td>
					</tr>
					<tr>
						<td>Fuel Adj.</td>
						<td class="align-right" data-label="750 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.fuelAdj750KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency allowNegative="true" />
							<span *ngIf="!canEdit" class="input-field">{{ model.fuelAdj750KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="1,500 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.fuelAdj1500KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency allowNegative="true" />
							<span *ngIf="!canEdit" class="input-field">{{ model.fuelAdj1500KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="30 kW 6,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.fuelAdj30KW6000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency allowNegative="true" />
							<span *ngIf="!canEdit" class="input-field">{{ model.fuelAdj30KW6000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="40 kW 10,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.fuelAdj40KW10000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency allowNegative="true" />
							<span *ngIf="!canEdit" class="input-field">{{ model.fuelAdj40KW10000KWH | currency }}</span>
						</td>
					</tr>
					<tr *ngIf="model.isInvestorOwned">
						<td>Storm Hardening</td>
						<td class="align-right" data-label="750 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.stormHardening750KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.stormHardening750KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="1,500 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.stormHardening1500KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.stormHardening1500KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="30 kW 6,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.stormHardening30KW6000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.stormHardening30KW6000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="40 kW 10,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.stormHardening40KW10000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.stormHardening40KW10000KWH | currency }}</span>
						</td>
					</tr>
					<tr>
						<td>Total</td>
						<td class="align-right" data-label="750 kWh">
							<span class="input-field">{{ +model.baseRate750KWH + +model.fuelAdj750KWH + +model.stormHardening750KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="1,500 kWh">
							<span class="input-field">{{ +model.baseRate1500KWH + +model.fuelAdj1500KWH + +model.stormHardening1500KWH| currency }}</span>
						</td>
						<td class="align-right" data-label="30 KW 6,000 kWh">
							<span class="input-field">{{ +model.baseRate30KW6000KWH + +model.fuelAdj30KW6000KWH + +model.stormHardening30KW6000KWH  | currency  }}</span>
						</td>
						<td class="align-right" data-label="40 KW 10,000 kWh">
							<span class="input-field">{{ +model.baseRate40KW10000KWH + +model.fuelAdj40KW10000KWH + +model.stormHardening40KW10000KWH | currency  }}</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="row center-div">
			<h4 class="table-header-format col-md-6">Commercial/Industrial Service</h4>
		</div>
		

		<div class="col-md center-div">	
			<table class="data-grid">
				<thead class="daily-count-tbl">
					<tr>
						<th></th>
						<th class="align-right">75 KW 15,000 kWh</th>
						<th class="align-right">75 KW 30,000 kWh</th>
						<th class="align-right">150 KW 30,000 kWh</th>
						<th class="align-right">150 KW 60,000 kWh</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>Base Rate</td>
						<td class="align-right" data-label="75 kW 15,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.baseRate75KW15000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.baseRate75KW15000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="75 kW 30,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.baseRate75KW30000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.baseRate75KW30000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="150 kW 30,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.baseRate150KW30000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.baseRate150KW30000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="150 kW 60,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.baseRate150KW60000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.baseRate150KW60000KWH | currency }}</span>
						</td>
					</tr>
					<tr>
						<td>Fuel Adj.</td>
						<td class="align-right" data-label="75 kW 15,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.fuelAdj75KW15000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency allowNegative="true" />
							<span *ngIf="!canEdit" class="input-field">{{ model.fuelAdj75KW15000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="75 kW 30,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.fuelAdj75KW30000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency allowNegative="true" />
							<span *ngIf="!canEdit" class="input-field">{{ model.fuelAdj75KW30000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="150 kW 30,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.fuelAdj150KW30000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency allowNegative="true" />
							<span *ngIf="!canEdit" class="input-field">{{ model.fuelAdj150KW30000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="150 kW 60,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.fuelAdj150KW60000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency allowNegative="true" />
							<span *ngIf="!canEdit" class="input-field">{{ model.fuelAdj150KW60000KWH | currency }}</span>
						</td>
					</tr>
					<tr *ngIf="model.isInvestorOwned">
						<td>Storm Hardening</td>
						<td class="align-right" data-label="75 kW 15,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.stormHardening75KW15000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.stormHardening75KW15000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="75 kW 30,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.stormHardening75KW30000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.stormHardening75KW30000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="150 kW 30,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.stormHardening150KW30000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.stormHardening150KW30000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="150 kW 60,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.stormHardening150KW60000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.stormHardening150KW60000KWH | currency }}</span>
						</td>
					</tr>
					<tr>
						<td>Total</td>
						<td class="align-right" data-label="75 kW 15,000 kWh">
							<span class="input-field">{{ +model.baseRate75KW15000KWH + +model.fuelAdj75KW15000KWH + +model.stormHardening75KW15000KWH| currency }}</span>
						</td>
						<td class="align-right" data-label="75 kW 30,000 kWh">
							<span class="input-field">{{ +model.baseRate75KW30000KWH + +model.fuelAdj75KW30000KWH + +model.stormHardening75KW30000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="150 kW 30,000 kWh">
							<span class="input-field">{{ +model.baseRate150KW30000KWH + +model.fuelAdj150KW30000KWH + +model.stormHardening150KW30000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="150 kW 60,000 kWh">
							<span class="input-field">{{ +model.baseRate150KW60000KWH + +model.fuelAdj150KW60000KWH + +model.stormHardening150KW60000KWH | currency }}</span>
						</td>
					</tr>
				</tbody>
			</table>
			<table class="data-grid">
				<thead class="daily-count-tbl">
					<tr>
						<th></th>
						<th class="admin align-right">300 kW 60,000 kWh</th>
						<th class="hand align-right">300 kW 120,000 kWh</th>
						<th class="hand align-right">500 kW 100,000 kWh</th>
						<th class="hand align-right">500 kW 200,000 kWh</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>Base Rate</td>
						<td class="align-right" data-label="300 kW 60,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.baseRate300KW60000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.baseRate300KW60000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="300 kW 120,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.baseRate300KW1200000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.baseRate300KW1200000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="500 kW 100,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.baseRate500KW100000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.baseRate500KW100000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="500 kW 200,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.baseRate500KW200000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.baseRate500KW200000KWH | currency }}</span>
						</td>
					</tr>
					<tr>
						<td>Fuel Adj.</td>
						<td class="align-right" data-label="300 kW 60,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.fuelAdj300KW60000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency allowNegative="true" />
							<span *ngIf="!canEdit" class="input-field">{{ model.fuelAdj300KW60000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="300 kW 120,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.fuelAdj300KW1200000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency allowNegative="true" />
							<span *ngIf="!canEdit" class="input-field">{{ model.fuelAdj300KW1200000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="500 kW 100,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.fuelAdj500KW100000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency allowNegative="true" />
							<span *ngIf="!canEdit" class="input-field">{{ model.fuelAdj500KW100000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="500 kW 200,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.fuelAdj500KW200000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency allowNegative="true" />
							<span *ngIf="!canEdit" class="input-field">{{ model.fuelAdj500KW200000KWH | currency }}</span>
						</td>
					</tr>
					<tr *ngIf="model.isInvestorOwned">
						<td>Storm Hardening</td>
						<td class="align-right" data-label="300 kW 60,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.stormHardening300KW60000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.stormHardening300KW60000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="300 kW 120,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.stormHardening300KW1200000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.stormHardening300KW1200000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="500 kW 100,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.stormHardening500KW100000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.stormHardening500KW100000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="500 kW 200,000 kWh">
							<input pcgControlRef *ngIf="canEdit" [(ngModel)]="model.stormHardening500KW200000KWH" [ngModelOptions]="{ standalone: true }"
								   class="form-control bigtxt input-field" required maxlength="9" style="width: 100%;" pcgDecimalNumber pcgCurrency />
							<span *ngIf="!canEdit" class="input-field">{{ model.stormHardening500KW200000KWH | currency }}</span>
						</td>
					</tr>
					<tr>
						<td>Total</td>
						<td class="align-right" data-label="300 kW 60,000 kWh">
							<span class="input-field">{{ +model.baseRate300KW60000KWH + +model.fuelAdj300KW60000KWH + +model.stormHardening300KW60000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="300 kW 120,000 kWh">
							<span class="input-field">{{ +model.baseRate300KW1200000KWH + +model.fuelAdj300KW1200000KWH + +model.stormHardening300KW1200000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="500 kW 100,000 kWh">
							<span class="input-field">{{ +model.baseRate500KW100000KWH + +model.fuelAdj500KW100000KWH + +model.stormHardening500KW100000KWH | currency }}</span>
						</td>
						<td class="align-right" data-label="500 kW 200,000 kWh">
							<span class="input-field">{{ +model.baseRate500KW200000KWH + +model.fuelAdj500KW200000KWH + +model.stormHardening500KW200000KWH | currency }}</span>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="center-div">
				<p>
					Rates for municipal utilities include payments in lieu of taxes, or transfer to the city's general fund, and any applicable 
					storm, conservation, environmental, and other charges generally applicable to customers.
					Rates for investor-owned utilities include any applicable conservation, capacity, environmental, storm recovery, 
					and other charges or fees generally applicable to customers. Final total columns include average 6% franchise fees for investor-owned utilities.
				</p>
			</div>
			<div class="center-div" style="text-align: center;">
				<button *ngIf="canEdit" type="submit" class="btn btn-success btn-lg">Submit Form</button>
			</div>
			
		</div>
		
	</form>
</div>
